<template>
    <fragment>
        <LoginHeader>

        </LoginHeader>

        <section class="hero">
            <div class="hero-body">
                <div class="container">
                    <fragment v-if="!error">
                        <h1 class="title">
                        <span v-if="loading">
                            Verifying your account...
                        </span>
                        <span v-if="!loading" class="verified">
                          <i class="fa fa-check"></i>  Verified
                        </span>
                        </h1>
                        <div class="sep-16"></div>
                        <h2 class="subtitle" v-if="!loading">
                            Your account email validated successfully,
                            <router-link :to="{'name': 'onboarding',
                              'query': {
                                  'type': this.isStartup ? 'stp' : 'ent'
                              }
                            }">click here</router-link>
                            to return to website.
                        </h2>
                    </fragment>
                    <fragment v-if="error">
                        <h1 class="title">
                            Something went wrong
                        </h1>
                        <div class="sep-16"></div>
                        <h2 class="subtitle" v-if="!loading">
                           Please try again or <a href="mailto:info@startupfalcon.com">contact us</a>.
                        </h2>
                    </fragment>
                </div>
            </div>
        </section>


    </fragment>
</template>

<script>
    import LoginHeader from "../../../shared/components/LoginHeader";
    import {LoginAPI} from "../../../apis/LoginAPI";
    import {getParameterByName} from "../../../shared/utils";
    import {mapGetters} from "vuex";

    export default {
        components: {LoginHeader},
        name: "VerfyEmail",
        data() {
            return {
                loading: true,
                error: false,
            }
        },
        async mounted() {
            try {
                this.loading = true;
                let resp = await LoginAPI.verifyUser(getParameterByName('token'));
                this.loading = false;
                if(!resp.is_valid){
                    this.error = true;
                }
            } catch (e) {
                this.error = true;
            }
        },
        methods: {},
        computed: {
          ...mapGetters(['isStartup',])
        }

    }
</script>

<style lang="scss" scoped>
    @import "../../../style/vars";

    .verified {
        color: $primary;
    }
</style>
